import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-add-notification-destination-gchat',
  templateUrl: './help-add-notification-destination-gchat.component.html',
  styleUrls: ['./help-add-notification-destination-gchat.component.scss']
})
export class HelpAddNotificationDestinationGchatComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
